import { render, staticRenderFns } from "./upload_fileForm.vue?vue&type=template&id=a70da9a8&scoped=true&"
import script from "./upload_fileForm.vue?vue&type=script&lang=js&"
export * from "./upload_fileForm.vue?vue&type=script&lang=js&"
import style0 from "./upload_fileForm.vue?vue&type=style&index=0&id=a70da9a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70da9a8",
  null
  
)

export default component.exports